import { render, staticRenderFns } from "./UpdateSchedule.vue?vue&type=template&id=3b398eb9&scoped=true&"
import script from "./UpdateSchedule.vue?vue&type=script&lang=js&"
export * from "./UpdateSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b398eb9",
  null
  
)

export default component.exports